import { Box, Flex } from "@chakra-ui/react";
import { FC, ReactNode } from "react";

import AppSidebar from "@/app/components/AppSidebar";
import { CommandBar } from "@/app/components/CommandBar";
import {
  TOP_BANNER_HEIGHT,
  TopBanner,
  useTopBanner,
} from "@/app/components/TopBanner";
import ErrorBoundary from "@/common/components/ErrorBoundary";

const APP_MIN_WIDTH = 1240;
const SIDEBAR_WIDTH = 190;
const SIDEBAR_SELECTOR = "reflag-primary-nav";
const MAIN_GUTTER = 6;

const AppLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const { showBanner } = useTopBanner();

  return (
    <Flex direction="column">
      <CommandBar />
      {showBanner && <TopBanner />}
      <Box
        h={
          showBanner
            ? `calc(100vh - var(--chakra-sizes-${TOP_BANNER_HEIGHT}))`
            : "100vh"
        }
        id={SIDEBAR_SELECTOR}
        left={0}
        pos="fixed"
        sx={{ "@media print": { display: "none" } }}
        top={showBanner ? TOP_BANNER_HEIGHT : 0}
        width={SIDEBAR_WIDTH}
      >
        <AppSidebar h="100%" minH="md" />
      </Box>
      <Box
        as="main"
        bg="appBackground"
        borderBottomWidth={0}
        borderColor="appBorder"
        borderRadius="md"
        borderStyle="solid"
        borderWidth={1}
        boxShadow="sm"
        display="flex"
        flexDirection="column"
        flexGrow={1}
        m={`${MAIN_GUTTER}px`}
        minHeight={`calc(100vh - ${2 * MAIN_GUTTER}px - 2px - ${
          showBanner ? `var(--chakra-sizes-${TOP_BANNER_HEIGHT})` : "0px"
        })`}
        minW={`${APP_MIN_WIDTH - SIDEBAR_WIDTH - 2 * MAIN_GUTTER}px`} // force into desktop size until we have better mobile support
        ml={SIDEBAR_WIDTH}
        pos="relative"
        sx={{
          "@media print": { marginLeft: 0 },
        }}
      >
        <ErrorBoundary>{children}</ErrorBoundary>
      </Box>
    </Flex>
  );
};

export default AppLayout;
